import { sharedTemplatesApi } from '@innovyze/stylovyze/lib/apis';
export const getLibraryListService = async () => {
    const response = await sharedTemplatesApi.get('/libraries');
    return response.data;
};
